import { Component } from 'react';
import PropTypes from 'prop-types';

class WebView extends Component {
    constructor(props) {
        super(props);
        require('./web-view.scss');
        //console.log("[WebView] props", props);
    }
    shouldComponentUpdate(nextProps) {
        //console.log("[WebView] shouldComponentUpdate:",this.props,"\n",nextProps);
        if(this.props.ready === true) {
            return false;
        }
        return true;
    }
    componentDidMount() {
        const { onDocumentReady, onWindowLoad, window, medscape, tracking } = this.props;
        const { document } = window;
        document.addEventListener('DOMContentLoaded', onDocumentReady.bind(this), true);
        window.addEventListener('load',onWindowLoad.bind(this), true );
        this.props.onReady(medscape,tracking);
    }

    componentWillUnMount() {
        const { onDocumentReady, onWindowLoad, window } = this.props;
        const { document } = window;
        document.removeEventListener('DOMContentLoaded', onDocumentReady.bind(this), true);
        window.removeEventListener('load',onWindowLoad.bind(this), true )
    }
    render() {
        if(this.props.ready === false) {
            return null;
        }
        return this.props.children
    }
    static get propTypes() {
        return {
            "children": PropTypes.any,
            "ready": PropTypes.bool,
            "onReady": PropTypes.func,
            "onDocumentReady": PropTypes.func, 
            "onWindowLoad": PropTypes.func,
            "tracking": PropTypes.object,
            "window": PropTypes.object,
            "medscape": PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            "ready": false,
            "onReady": () => {},
            "onDocumentReady": () => {}, 
            "onWindowLoad": () => {}, 
            "tracking": {},
            "window": window,
            "medscape": window.medscape
        }
    }
}
export default WebView;